module.exports = __webpack_public_path__ + "front/img/logo.190878ac.png";